/***
 *
 *   ICON
 *   Render an icon from feather icons
 *
 *   PROPS
 *   color: dark/light/grey/green/orange/blue or hex code
 *   pack: icon pack to use, default is feathericons
 *   image: image to use (see: https://feathericons.com)
 *   className: inject a parent class object
 *
 **********/

import FeatherIcon from 'feather-icons-react';

import AnnotationQuestion from '@untitled-ui/icons-react/build/cjs/AnnotationQuestion';
import Announcement03 from '@untitled-ui/icons-react/build/cjs/Announcement03';
import Home01 from '@untitled-ui/icons-react/build/cjs/Home01';
import User01 from '@untitled-ui/icons-react/build/cjs/User01';
import BookOpen01 from '@untitled-ui/icons-react/build/cjs/BookOpen01';
import LogOut01 from '@untitled-ui/icons-react/build/cjs/LogOut01';

interface IconProps {
  color?: 'light' | 'dark' | 'grey' | 'green' | 'blue' | 'orange' | 'red' | 'purple' | string;
  image?: string;
  size?: number | string;
  className?: string;
}

export function Icon(props: IconProps) {
  let color;

  const icons: Record<string, React.ElementType> = {
    help: AnnotationQuestion,
    support: Announcement03,
    guide: BookOpen01,
    dashboard: Home01,
    logout: LogOut01,
    user: User01,
    feather: FeatherIcon,
  };

  // Determine color based on props
  switch (props.color) {
    case 'light':
      color = '#FFFFFF';
      break;
    case 'dark':
      color = '#758197';
      break;
    case 'grey':
      color = '#ccc';
      break;
    case 'green':
      color = '#8CC57D';
      break;
    case 'blue':
      color = '#73B0F4';
      break;
    case 'orange':
      color = '#F0AA61';
      break;
    case 'red':
      color = '#d95565';
      break;
    case 'purple':
      color = '#6363AC';
      break;
    default:
      color = props.color;
      break;
  }

  // Retrieve the correct icon component
  const SelectedIcon = (props.image && icons[props.image]) || icons['feather'];

  // Check if the icon exists
  if (!SelectedIcon) {
    console.error(`Icon "${props.image}" not found.`);
    return null;
  }

  // Render the icon component with the provided props
  return (
    <SelectedIcon icon={props.image} color={color} width={props.size} height={props.size} className={props.className} />
  );
}
